import { SEATERS_STATIC_BASE_URL } from '../env';

/**
 * Constructs the URL for custom translation files stored in S3
 * @param slug - The fangroup slug
 * @param target - The translation target (web, guest, etc.)
 * @param language - The language code (en, fr, nl_NL, etc.)
 * @returns The complete URL to the custom translations file
 */
export const buildCustomTranslationsUrl = (
  slug: string,
  target: string,
  language: string
): string => {
  const baseUrl = SEATERS_STATIC_BASE_URL;
  return `${baseUrl}custom-translations/${slug}/${target.toLowerCase()}/${language}.json`;
};
